import * as S from './Note.styles';
import CountdownTimer from '../../component/CountdownTimer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const Note: React.FC<{ setIsCountdownFinished: (finished: boolean) => void }> = ({ setIsCountdownFinished }) => {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState<number>(120);

  const handleTimeout = () => {
    setIsCountdownFinished(true);
  };

  return (
    <>
      <S.Header>
        <CountdownTimer initialTime={timeLeft} onTimeout={handleTimeout} />
      </S.Header>
      <S.Wrapper>
        <S.Content>
          <p>{t('page.mockTest.note1.description')}</p>
          <p>{t('page.mockTest.note1.description1')}</p>
          <p>{t('page.mockTest.note1.description2')}</p>
        </S.Content>
      </S.Wrapper>
    </>
  );
};
